 <template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 10px auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>首页分组配置</h4>
          <div>
            <el-button type="primary" class="adduser" @click="handleReturn">返回首页</el-button>
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="分组名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="排序号">
              <template slot-scope="scope">
                <p>{{ scope.row.orderNum }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="pagination-container">
      <div class="page"></div>
      <div class="pagination-content-container">
        <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="分组名称：" prop="groupIdArr">
              <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange2" placeholder="请选择分组名称" collapse-tags clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="排序号：" prop="orderNum">
              <el-input-number v-model="ruleForm.orderNum" placeholder="请输入排序号" :min="0" :max="9999" size="small" :precision="0" :step="1">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: '',
        groupIdArr: [],
        groupId: '',
        orderNum: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ],
        orderNum: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          }
        ]
      },
      addEditTitle: '添加首页分组配置', // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      groupArray: [], // 分组名称数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      }
    }
  },
  created() {
    // 查询
    this.getList()

    // 获取分组列表
    this.getGroupList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupParamId: ''
      }
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.$api.homeParam.getSysHomeGroupList(this.searchForm).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.homeParam.delSysHomeGroup(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑首页分组配置'
      this.ruleForm.id = row.id

      // 获取详情
      this.$api.homeParam.getSysHomeGroup({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
          this.ruleForm = res.data
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加首页分组配置'
      this.ruleForm.id = ''
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.homeParam.saveSysHomeGroup(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 分组下拉切换2
    groupChange2() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map((item) => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `homePage`,
        query: {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>